import { User } from './user';

export class Alarm {
    private warning: Boolean = false;
    private alarm: Boolean = false;
    private answerSheetId: String;
    private id: String;
    private collected_at: Number;
    private result: Boolean;
    private rule: String;
    private headline: String;
    private text: String;
    private explanation: String;
    private cause: String;
    private user: User;
    private studyId: String;
    private questionnaireId: String;

    public constructor(id: String, answerSheetId: String) {
        this.id = id;
        this.answerSheetId = answerSheetId;
    }

    public setId(id: String) { this.id = id; }
    public getId() { return this.id; }
    public setAnswersheetId(id: String) { this.answerSheetId = id; }
    public getAnswersheetId() { return this.answerSheetId; }
    public setWarning(warning: Boolean) { this.warning = warning; }
    public isWarning() { return this.warning; }
    public setAlarm(alarm: Boolean) { this.alarm = alarm; }
    public isAlarm() { return this.alarm; }
    public setCollectedAt(coll: Number) { this.collected_at = coll; }
    public getCollectedAt() { return this.collected_at; }
    public setResult(result: Boolean) { this.result = result; }
    public getResult() { return this.result; }
    public setRule(rule: String) { this.rule = rule; }
    public getRule() { return this.rule; }
    public setHeadline(headline: String) { this.headline = headline; }
    public getHeadline() { return this.headline; }
    public setText(text: String) { this.text = text; }
    public getText() { return this.text; }
    public setExplanation(explanation: String) { this.explanation = explanation; }
    public getExplanation() { return this.explanation; }
    public setCause(cause: String) { this.cause = cause }
    public getCause() { return this.cause }
    public setUser(user: User) { this.user = user; }
    public getUser() { return this.user; }
    public setStudyId(studyId: String) { this.studyId = studyId; }
    public getStudyId() { return this.studyId; }
    public setQuestionnaireId(q: String) { this.questionnaireId = q; }
    public getQuestionnaireId() { return this.questionnaireId; }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/alarm.ts